<template>
  <!-- Header Section -->
    <div class="row wrapper border-bottom white-bg page-heading">
        <!-- Title on the left -->
        <div class="col-lg-8 align-self-center">
        <h2 class="mb-0">
            {{ $t("navigations.organization_settings") }} -
            <small>
            {{
                $t("navigations.manage your organizations profile-branding and information")
            }}</small
            >
        </h2>
        </div>
    </div>
    <div class="row mt-2">
        <!-- Left Column -->
        <div class="col-lg-6 px-1">
                <!-- Logo Upload Card -->
                <div class="ibox-title style_2">
                    <h5>Organization Logo</h5>
                </div>
                <div class="ibox-content contact-card">
                    <div class="logo-preview-container" id="logoUploadArea">
                        <div class="logo-placeholder">
                            <i class="fa fa-cloud-upload"></i>
                        </div>
                        <img id="logoPreview" class="logo-preview" src="" alt="Logo preview">
                        <p class="upload-text">Click to upload your organization logo</p>
                        <p class="upload-hint pb-0">Recommended size: 500x200 pixels • Max file size: 5MB</p>
                        <input type="file" id="logoInput" class="file-input" accept="image/*">
                    </div>
                    
                    <div class="action-buttons">
                        <button class="cancel_btn py-1 px-4 mx-3" id="removeLogoBtn">
                            Remove Logo
                        </button>
                        <button class="save_btn py-1 px-4" id="saveLogoBtn">
                            Save
                        </button>
                    </div>
                </div>
        </div>
        <div class="col-lg-6 px-1">
                <div class="ibox-title style_2">
                    <h5>Contact Information</h5>
                </div>
                <div class="ibox-content contact-card">
                        <div class="contact-item">
                            <div class="contact-icon">
                                <i class="fa fa-map-marker"></i>
                            </div>
                            <div class="d-flex">
                                <div>Headquarters:  <span class="fw-bold">123 Research Park, London, UK</span></div>
                            </div>
                        </div>
                        
                        <div class="contact-item">
                            <div class="contact-icon">
                                <i class="fa fa-phone"></i>
                            </div>
                            <div class="d-flex">
                                <div>Phone:  <span class="fw-bold">+44 20 7123 4567</span></div>
                            </div>
                        </div>
                        
                        <div class="contact-item">
                            <div class="contact-icon">
                                <i class="fa fa-envelope"></i>
                            </div>
                            <div class="d-flex">
                                <div>Email:  <span class="fw-bold">contact@datamatica.uk</span></div>
                            </div>
                        </div>
                    <div class="action-buttons">
                        <button class="cancel_btn py-1 px-4 mx-3" id="editContactBtn">
                            Edit
                        </button>
                        <button class="save_btn py-1 px-4" id="saveContactBtn">
                            Save
                        </button>
                    </div>
                </div>
        </div>
        <div class="col-lg-12 px-1">
                <!-- Organization Details Card -->
                 <div class="ibox-title style_2 mt-2">
                    <h5>Organization Details</h5>
                </div>
                <div class="ibox-content">
                    <div class="org-info d-flex justify-content-between">
                        <div class="mb-3">
                            <label for="orgName" class="form-label fw-bold">Organization Name</label>
                            <input type="text" class="form-control" id="orgName" value="DataMatica Research" placeholder="Enter organization name">
                        </div>
                        
                        <div class="mb-3">
                            <label for="orgWebsite" class="form-label fw-bold">Website</label>
                            <input type="url" class="form-control" id="orgWebsite" value="https://datamatica.uk" placeholder="https://your-organization.com">
                        </div>
                        
                        <div class="mb-3">
                            <label for="orgIndustry" class="form-label fw-bold">Industry</label>
                            <select class="form-select" id="orgIndustry">
                                <option>Select industry</option>
                                <option selected>Healthcare & Life Sciences</option>
                                <option>Information Technology</option>
                                <option>Financial Services</option>
                                <option>Education</option>
                                <option>Research & Development</option>
                            </select>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="orgDescription" class="form-label fw-bold">About Organization</label>
                        <textarea class="form-control" id="orgDescription" rows="6" placeholder="Tell us about your organization...">DataMatica Research is a leading clinical research organization specializing in innovative healthcare solutions. We partner with research institutions and pharmaceutical companies to conduct cutting-edge clinical trials that advance medical knowledge and improve patient outcomes.
                        Our team of experienced researchers, clinicians, and data scientists work collaboratively to design and execute studies that meet the highest scientific and ethical standards. With state-of-the-art facilities and a commitment to excellence, we accelerate the development of new therapies and medical technologies.</textarea>
                    </div>
                    
                    <div class="info-box">
                        <div class="info-title">Best Practices</div>
                        <p class="mb-0">Provide a clear and concise description of your organization. Include your mission, areas of expertise, and any notable achievements. This information helps build trust with partners and clients.</p>
                    </div>
                    
                    <div class="action-buttons">
                        <button class="cancel_btn py-1 px-4 ">
                            Edit
                        </button>
                        <button class="save_btn py-1 px-4" id="saveOrgDetailsBtn">
                            Save Information
                        </button>
                    </div>
                </div>
        </div>
    </div> 
</template>
<script src="./organization_settings.js"></script>
<style scoped>
        :root {
            --primary-color: #4361ee;
            --secondary-color: #3f37c9;
            --accent-color: #4895ef;
            --light-bg: #f8f9fa;
            --dark-text: #212529;
            --border-color: #e1e5eb;
        }

        .ibox:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
        }
        
        .card-title {
            font-weight: 600;
            color: var(--primary-color);
            margin-bottom: 25px;
            padding-bottom: 15px;
            border-bottom: 2px solid var(--border-color);
            display: flex;
            align-items: center;
            gap: 12px;
        }
        
        .logo-preview-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 4px;
            border: 2px dashed var(--border-color);
            border-radius: 12px;
            background: var(--light-bg);
            cursor: pointer;
            transition: all 0.3s;
            position: relative;
            overflow: hidden;
            min-height: 150px;
            justify-content: center;
        }
        
        .logo-preview-container:hover {
            border-color: var(--accent-color);
            background: rgba(72, 149, 239, 0.05);
        }
        
        .logo-preview {
            width:auto;
            height: 56px;
            margin-bottom: 5px;
            display: none;
        }
        
        .logo-placeholder {
            font-size: 2rem;
            color: #adb5bd;
            margin-bottom: 5px;
        }
        
        .upload-text {
            font-size: .8rem;
            font-weight:600;
            color: #495057;
            text-align: center;
            margin-bottom: 5px;
        }
        
        .upload-hint {
            color: #6c757d;
            font-size: 0.8rem;
            font-style:italic;

        }
        
        .file-input {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            opacity: 0;
            cursor: pointer;
        }
        
        .form-control, .form-select {
            border: 2px solid var(--border-color) !important;
            border-radius: 8px;
            padding: 12px 15px;
            font-size: 1rem;
        }
        
        .form-control:focus, .form-select:focus {
            border-color: var(--accent-color);
            box-shadow: 0 0 0 0.25rem rgba(67, 97, 238, 0.15);
        }
        
        .btn-primary {
            background: var(--primary-color);
            border: none;
            padding: 12px 24px;
            font-weight: 600;
            border-radius: 8px;
            transition: all 0.3s;
        }
        
        .btn-primary:hover {
            background: var(--secondary-color);
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(67, 97, 238, 0.3);
        }
        
        .btn-outline {
            background: transparent;
            border: 2px solid var(--border-color);
            color: #495057;
            padding: 12px 24px;
            font-weight: 600;
            border-radius: 8px;
            transition: all 0.3s;
        }
        
        .btn-outline:hover {
            border-color: var(--accent-color);
            color: var(--accent-color);
        }
        
        .info-box {
            background: #f0f7ff;
            border-left: 4px solid var(--accent-color);
            padding: 20px;
            border-radius: 0 8px 8px 0;
            margin: 20px 0;
        }
        
        .info-title {
            font-weight: 600;
            color: var(--primary-color);
            margin-bottom: 10px;
        }
        
        .contact-card {
            min-height:250px;
        }
        
        .contact-item {
            display: flex;
            align-items: center;
            gap: 5px;
            padding-bottom: 10px;
        }
        
        .contact-item:last-child {
            margin-bottom: 0;
            padding-bottom: 0;
            border-bottom: none;
        }
        
        .contact-icon {
            width: 40px;
            height: 40px;
            background: rgba(67, 97, 238, 0.1);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: var(--primary-color);
            font-size: 1.2rem;
        }
        
        .footer {
            text-align: center;
            padding: 30px 0;
            color: #6c757d;
            font-size: 0.9rem;
        }
        
        .action-buttons {
            display: flex;
            gap: 5px;
            justify-content: flex-end;
            padding-top: 14px;
            margin-top: 9px;
            border-top: 2px solid #f6f6f6;
        }
        
        @media (max-width: 768px) {
            .settings-container {
                margin: 20px auto;
            }
            
            .settings-header, .settings-card {
                padding: 20px;
            }
            
            .action-buttons {
                flex-direction: column;
            }
            
            .action-buttons .btn {
                width: 100%;
            }
        }
        
        /* Header with logos */
        .header-logos {
            background: white;
            padding: 20px 0;
            border-bottom: 1px solid var(--border-color);
            margin-bottom: 30px;
        }
        
        .header-logos .row {
            align-items: center;
        }
        
        .form-logos {
            text-align: center;
        }
        
        .form-logos img {
            max-height: 70px;
            max-width: 100%;
        }
        
        .form-header {
            font-weight: 600;
            color: var(--primary-color);
            margin: 0;
        }
</style>